import {ArrowRight, Syringe, Zap} from 'lucide-react'

function Hero() {
  const scrollTo = (href: string) => {
    document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' })
  }

  return (
    <section id="top" className="relative overflow-hidden bg-[#0a0908] px-4 pb-20 pt-16 sm:px-6 sm:pt-24 lg:px-8 lg:pt-28">
      <div
        className="pointer-events-none absolute inset-0 opacity-40"
        style={{
          backgroundImage: 'radial-gradient(circle at 20% 20%, rgba(217,161,53,0.12), transparent 45%), radial-gradient(circle at 80% 0%, rgba(217,161,53,0.10), transparent 40%)',
        }}
        aria-hidden="true"
      />
      <div className="relative mx-auto max-w-4xl text-center">
        <span className="mb-6 inline-flex items-center gap-2 rounded-full border border-amber-500/30 bg-amber-500/10 px-4 py-1.5 text-xs font-medium uppercase tracking-widest text-amber-300">
          Free & Instant Estimate Tool
        </span>
        <h1 className="font-serif text-4xl font-bold leading-tight tracking-tight text-white sm:text-5xl lg:text-6xl">
          Calculate Your Next Masterpiece:
          <span className="block text-amber-400">Advanced Tattoo Cost Calculator</span>
        </h1>
        <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-slate-300 sm:text-lg">
          Get an accurate <strong className="text-slate-100">tattoo price calculator</strong> estimate in seconds by
          size, placement, and artist tier &mdash; or use our
          <strong className="text-slate-100"> laser tattoo removal cost per session</strong> calculator to plan your
          full removal journey. No guesswork, just real studio pricing data.
        </p>
        <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
          <button
            type="button"
            onClick={() => scrollTo('#tattoo-calculator')}
            className="group inline-flex w-full items-center justify-center gap-2 rounded-full bg-amber-500 px-8 py-4 text-base font-semibold text-black shadow-xl shadow-amber-500/25 transition-transform hover:scale-105 hover:bg-amber-400 sm:w-auto"
          >
            <Syringe className="h-5 w-5" aria-hidden="true" />
            Estimate Tattoo Cost
            <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" aria-hidden="true" />
          </button>
          <button
            type="button"
            onClick={() => scrollTo('#laser-calculator')}
            className="inline-flex w-full items-center justify-center gap-2 rounded-full border border-amber-500/40 bg-white/5 px-8 py-4 text-base font-semibold text-amber-200 transition-colors hover:border-amber-400 hover:bg-white/10 sm:w-auto"
          >
            <Zap className="h-5 w-5" aria-hidden="true" />
            Estimate Removal Cost
          </button>
        </div>
        <p className="mt-6 text-xs uppercase tracking-widest text-slate-500">
          Trusted formulas &middot; Real studio rate data &middot; Updated pricing standards
        </p>
      </div>
    </section>
  )
}

export default Hero
